import React, { createContext, useMemo, useState } from 'react';

type EnvironmentPermissionContextType = {
    allowWIP: boolean;
};

export const EnvironmentPermissionContext = createContext<EnvironmentPermissionContextType>(undefined);

export const EnvironmentPermissionProvider = ({ children }) => {
    const namespace = window._env_.NAMESPACE;
    const [allowWip, setAllowWip] = useState(false);

    /**
     * @todo: Instead of using memo, we could use initializer function in the useState for allowWip and set it based on the namespace value. This way we can avoid using useMemo and directly set the value during initialization.
     * Additionally, that value can be a ref instead of state since it doesn't seem to be changing after initialization, which would further simplify the code and avoid unnecessary re-renders.
     */
    const providerValue = useMemo(() => {
        if (namespace === 'dev') {
            setAllowWip(true);
        }
        return { allowWIP: allowWip };
    }, [namespace, allowWip]);

    return (
        <EnvironmentPermissionContext.Provider value={providerValue}>{children}</EnvironmentPermissionContext.Provider>
    );
};
